<h4 class="iching-commentary__title">{{ t('humanDesign.iching.commentary.title') }}</h4>
@for (id of sections(); track id) {
  <section class="iching-commentary__section" [attr.data-iching-commentary-section]="id">
    <button type="button" class="iching-commentary__toggle" (click)="toggle(id)" [attr.aria-expanded]="openSections().has(id)">
      <span class="iching-commentary__chevron" aria-hidden="true">›</span>
      {{ t('humanDesign.iching.commentary.' + id) }}
    </button>
    @if (openSections().has(id)) {
      <div class="iching-commentary__body">
        @switch (id) {
          @case ('rulers') {
            <hd-iching-prose class="iching-prose" [paragraphs]="commentary().rulers" path="commentary.rulers" [footnotes]="footnotes()" />
          }
          @case ('remarks') {
            <hd-iching-prose class="iching-prose" [paragraphs]="commentary().remarks ?? []" path="commentary.remarks" [footnotes]="footnotes()" />
          }
          @case ('lines') {
            @for (segment of commentary().linesIntro ?? []; track $index; let si = $index) {
              @if (segment.heading) {
                <h5>{{ segment.heading }}</h5>
              }
              <hd-iching-prose class="iching-verse" paragraphClass="is-verse" [paragraphs]="segment.quote" [path]="'commentary.linesIntro[' + si + '].quote'" [footnotes]="footnotes()" />
              <hd-iching-prose class="iching-prose" [paragraphs]="segment.commentary" [path]="'commentary.linesIntro[' + si + '].commentary'" [footnotes]="footnotes()" />
            }
            @for (line of commentary().lines; track line.position; let li = $index) {
              <div class="iching-commentary__line" [attr.data-iching-commentary-line]="line.position">
                <div class="iching-commentary__line-label">{{ line.label }}</div>
                <hd-iching-prose class="iching-verse" paragraphClass="is-verse" [paragraphs]="line.b" [path]="'commentary.lines[' + li + '].b'" [footnotes]="footnotes()" />
                <hd-iching-prose class="iching-prose" [paragraphs]="line.explanation" [path]="'commentary.lines[' + li + '].explanation'" [footnotes]="footnotes()" />
              </div>
            }
            @if (commentary().allLines; as all) {
              <div class="iching-commentary__line iching-commentary__line--all">
                <div class="iching-commentary__line-label">{{ all.label }}</div>
                <hd-iching-prose class="iching-verse" paragraphClass="is-verse" [paragraphs]="all.b" path="commentary.allLines.b" [footnotes]="footnotes()" />
                <hd-iching-prose class="iching-prose" [paragraphs]="all.explanation" path="commentary.allLines.explanation" [footnotes]="footnotes()" />
              </div>
            }
          }
          @case ('wenYan') {
            <hd-iching-prose class="iching-prose" [paragraphs]="commentary().wenYan?.intro ?? []" path="commentary.wenYan.intro" [footnotes]="footnotes()" />
            @for (item of commentary().wenYan?.items ?? []; track $index; let wi = $index) {
              <div class="iching-commentary__ref">{{ item.ref }}</div>
              <hd-iching-prose class="iching-verse" paragraphClass="is-verse" [paragraphs]="item.text" [path]="'commentary.wenYan.items[' + wi + '].text'" [footnotes]="footnotes()" />
              <hd-iching-prose class="iching-prose" [paragraphs]="item.commentary" [path]="'commentary.wenYan.items[' + wi + '].commentary'" [footnotes]="footnotes()" />
            }
          }
          @default {
            @for (segment of segments(id); track $index; let si = $index) {
              @if (segment.heading) {
                <h5>{{ segment.heading }}</h5>
              }
              <hd-iching-prose class="iching-verse" paragraphClass="is-verse" [paragraphs]="segment.quote" [path]="'commentary.' + id + '[' + si + '].quote'" [footnotes]="footnotes()" />
              <hd-iching-prose class="iching-prose" [paragraphs]="segment.commentary" [path]="'commentary.' + id + '[' + si + '].commentary'" [footnotes]="footnotes()" />
            }
          }
        }
      </div>
    }
  </section>
}
